import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  MenuItem,
  TextField,
  Typography,
  Grid,
  FormControl,
} from "@mui/material";
import { Formik, Form, useFormik } from "formik";
import * as Yup from "yup";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";
import SessionStorageService from "../../services/StorageService";
import CaddeSokakAPI from "../../apis/OB/Get/CaddeSokakAPI";
import ProjeKategoriAPI from "../../apis/OB/Get/ProjeKategoriAPI";
import TcTelefonSmsControlPopup from "../../components/OB/popups/tc-telefon-fogrulama-popup";
import ProjeOnerileriSave from "../../apis/OB/SaveApi/ProjeOnerileriSave";
import BilgilendirmePopup from "../../components/OB/popups/BilgilendirmePopUp";
import { safelyParseNumber } from "../../helpers/MoneyFormat";

const ProjeOnerileri = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const user = SessionStorageService.getUserInfo();
  
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState(-1);
  const [caddeSokakDatas, setCaddeSokakDatas] = useState([]);
  const [projeKategoriListe, setProjeKategoriListe] = useState([]);
  const [smsControlled, setSmsControlled] = useState(user != null ? true : false);
  const [cepTelefonu, setCepTelefonu] = useState("");
  const [tcKimlikNo, setTcKimlikNo] = useState("");

  useEffect(() => {
    ProjeKategoriAPI.getProjeKategori().then((res) => {
      setProjeKategoriListe(res.data);
    });
  }, []);

  useEffect(() => {
    if (selectedMahalleKodu !== -1) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu).then((res) => {
        setCaddeSokakDatas(res.data);
      });
    }
  }, [selectedMahalleKodu]);

  return (
    <Container>
      {smsControlled ? (
        <Container maxWidth="md">
          <Formik
            initialValues={{
              kullaniciKodu: "",
              tcKimlikNo: user != null ? user.tcKimlikNo : tcKimlikNo,
              cepTelefonu: user != null ? user.cepTelefonu : cepTelefonu,
              projeKategoriKodu: -1,
              projeAdi: "",
              projeFayda: "",
              projeIcerik: "",
              medyaYayinEH: "",
              selectedMahalleKodu: -1,
              selectedCaddeSokakKodu: -1,
            }}
            validationSchema={Yup.object({
              projeKategoriKodu: Yup.number().min(0, "Lütfen bir kategori seçin").required("Gerekli"),
              projeAdi: Yup.string().required("Gerekli"),
              projeFayda: Yup.string().required("Gerekli"),
              projeIcerik: Yup.string().required("Gerekli"),
              medyaYayinEH: Yup.string().required("Gerekli"),
              selectedMahalleKodu: Yup.number().min(0, "Lütfen bir mahalle seçin").required("Gerekli"),
              selectedCaddeSokakKodu: Yup.number().min(0, "Lütfen bir cadde/sokak seçin").required("Gerekli"),
            })}
            onSubmit={(values:any, { resetForm }) => {
              const formattedValues:any = {
                kullaniciKodu: user.sqId,
                tcKimlikNo: safelyParseNumber(user ? user.tcKimlikNo : values.tcKimlikNo),
                cepTelefonu: safelyParseNumber(user ? user.cepTelefonu : values.cepTelefonu),
                projeKategoriKodu: safelyParseNumber(values.projeKategoriKodu),
                projeAdi: values.projeAdi,
                projeFayda: values.projeFayda,
                projeIcerik: values.projeIcerik,
                medyaYayinEH: values.medyaYayinEH,
                mahalleKodu: safelyParseNumber(values.selectedMahalleKodu),
                caddeSokakKodu: safelyParseNumber(values.selectedCaddeSokakKodu),
              };

              console.log("submitted", formattedValues);
              ProjeOnerileriSave.saveProjeOneriSave(formattedValues)
                .then((res) => {
                  console.log(res);
                  if (res.data.sonuc === 0) {
                    setPopupAciklama(
                      "İşleminiz başarıyla gerçekleştirildi. "
                    );
                    resetForm();
                    setKayitBasarili(true);
                  } else {
                    setPopupAciklama(res.data.sonucAciklama);
                  }
                })
                .catch((err) => {
                  setPopupAciklama(
                    "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
                  );
                })
                .finally(() => {
                  setIsPopupVisible(true);
                });
            }}
          >
            {formik => (
              <Form>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      
                    >
                      <TextField
                        sx={{
                          backgroundColor: "white"
                        }}
                        select
                        label="Proje Kategorisi"
                        name="projeKategoriKodu"
                        error={formik.touched.projeKategoriKodu && Boolean(formik.errors.projeKategoriKodu)}
                        value={formik.values.projeKategoriKodu}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <MenuItem value={-1}>Seçiniz</MenuItem>
                        {projeKategoriListe.map((item:any, index) => (
                          <MenuItem key={index} value={item.projeKategoriKodu}>
                            {item.projeKategoriAdi}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      sx={{
                        backgroundColor: "white"
                      }}
                      fullWidth
                      name="projeAdi"
                      label="Proje Adı"
                      value={formik.values.projeAdi}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.projeAdi && Boolean(formik.errors.projeAdi)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      sx={{
                        backgroundColor: "white"
                      }}
                      fullWidth
                      name="projeFayda"
                      label="Projeden Beklenen Fayda"
                      value={formik.values.projeFayda}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.projeFayda && Boolean(formik.errors.projeFayda)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      sx={{
                        backgroundColor: "white"
                      }}
                      fullWidth
                      name="projeIcerik"
                      label="Projenin İçeriğini Anlatınız"
                      value={formik.values.projeIcerik}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.projeIcerik && Boolean(formik.errors.projeIcerik)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                    >
                      <Typography>Projenin öneriniz Web sitelerimizde ve medya kanallarında yayınlansın mı?</Typography>
                      <TextField
                        sx={{
                          backgroundColor: "white"
                        }}
                        name="medyaYayinEH"
                        select
                        error={formik.touched.medyaYayinEH && Boolean(formik.errors.medyaYayinEH)}

                        placeholder="Seçiniz"
                        value={formik.values.medyaYayinEH}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <MenuItem value="">Seçiniz</MenuItem>
                        <MenuItem value="E">Evet</MenuItem>
                        <MenuItem value="H">Hayır</MenuItem>
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                    >
                      <TextField
                        sx={{
                          backgroundColor: "white"
                        }}
                        select
                        error={formik.touched.selectedMahalleKodu && Boolean(formik.errors.selectedMahalleKodu)}

                        label="Mahalle Adı"
                        name="selectedMahalleKodu"
                        value={formik.values.selectedMahalleKodu}
                        onChange={(e) => {
                          formik.handleChange(e);
                          setSelectedMahalleKodu(Number(e.target.value));
                        }}
                        onBlur={formik.handleBlur}
                      >
                        <MenuItem value={-1}>Mahalle</MenuItem>
                        {mahalleListe.map((item, index) => (
                          <MenuItem key={index} value={item.mahalleKodu}>
                            {item.mahalleAdi}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                    >
                      <TextField
                        sx={{
                          backgroundColor: "white"
                        }}
                        label="Cadde/ Sokak"
                        select
                        name="selectedCaddeSokakKodu"
                        error={formik.touched.selectedCaddeSokakKodu && Boolean(formik.errors.selectedCaddeSokakKodu)}

                        value={formik.values.selectedCaddeSokakKodu}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <MenuItem value={-1}>Cadde/Sokak</MenuItem>
                        {caddeSokakDatas.map((item:any, index) => (
                          <MenuItem key={index} value={item.caddeSokakKodu}>
                            {item.caddeSokakAdi}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} className="d-flex gap-2 flex-column flex-md-row">
                    <Button  color="primary" type="submit" fullWidth>
                      Gönder
                    </Button>
                    <Button onClick={()=>formik.resetForm()} color="secondary" fullWidth>Temizle</Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
          {isPopupVisible && (
            <BilgilendirmePopup
              basvuruTuruId={-3}
              isSorunBildirPopup={!kayitBasarili}
              closePopup={closePopupSonuc}
              open={isPopupVisible}
              editDescription={popupAciklama}
            />
          )}
        </Container>
      ) : (
        <TcTelefonSmsControlPopup
          smsControlledSet={setSmsControlled}
          cepTelefonuSet={setCepTelefonu}
          tcKimlikNoSet={setTcKimlikNo}
        />
      )}
    </Container>
  );
};

export default ProjeOnerileri;
